export const project_code_data_headers = [
    { text: "No.", align: "center", value: "id" },
    { text: "승인 단계", align: "center", value: "approvalPhase" },
    { text: "품의서", align: "center", value: "approvalDocumentNumber" },
    { text: "확인자", align: "center", value: "checkerName" },
    { text: "승인자", align: "center", value: "approverName" },
    { text: "구매 담당자", align: "center", value: "createrName" },
    { text: "승인 요청일", align: "center", value: "createdTime" },
    { text: "발주 업체", align: "center", value: "companyName" },
    { text: "발주일", align: "center", value: "orderDate" },
    { text: "1차 발급일", align: "center", value: "firstBillDate" },
    { text: "2차 발급일", align: "center", value: "secondBillDate" },
    { text: "3차 발급일", align: "center", value: "thirdBillDate" },
];
